export const DEV_IMPERSONATION_HEADER = 'X-Dev-User-Email';
export const DEV_IMPERSONATION_STORAGE_KEY = 'devImpersonationEmail';

export const isDevImpersonationAvailable = () => process.env.NODE_ENV === 'development';

export const getDevImpersonationEmail = () => {
    if (!isDevImpersonationAvailable() || typeof window === 'undefined') {
        return '';
    }

    return window.sessionStorage.getItem(DEV_IMPERSONATION_STORAGE_KEY) || '';
};

export const setDevImpersonationEmail = (email) => {
    if (!isDevImpersonationAvailable() || typeof window === 'undefined') {
        return;
    }

    const normalizedEmail = (email || '').trim().toLowerCase();

    if (normalizedEmail) {
        window.sessionStorage.setItem(DEV_IMPERSONATION_STORAGE_KEY, normalizedEmail);
        return;
    }

    window.sessionStorage.removeItem(DEV_IMPERSONATION_STORAGE_KEY);
};

export const applyDevImpersonationHeader = (headers) => {
    const email = getDevImpersonationEmail();

    if (email && !headers.has(DEV_IMPERSONATION_HEADER)) {
        headers.set(DEV_IMPERSONATION_HEADER, email);
    }

    return headers;
};
